import type { AgentApiProfitsItem } from '@/types/serializers';
import { MaterialIcon } from '@/components/MaterialIcon';
import ProfitCardItem from './ProfitCardItem';
import type { ProfitAction } from './ProfitStatusMenu';

type Props = {
  profits: AgentApiProfitsItem[];
  isLoading: boolean;
  onAction: (profit: AgentApiProfitsItem, action: ProfitAction) => void;
  isSidebarOpen: boolean;
  openSidebar: (isValue: boolean) => void;
};

function ProfitCardSkeleton() {
  return (
    <div className="flex min-h-[80px] items-center justify-around rounded bg-white px-6 py-2 shadow-[0px_0px_6px_0px_#00000033]">
      <div className="flex w-[180px] min-w-[180px] flex-col justify-center gap-4">
        <div className="h-3 w-[174px] animate-skeleton rounded-full bg-border" />
        <div className="h-3 w-[74px] animate-skeleton rounded-full bg-border" />
      </div>
      <div className="flex w-[180px] min-w-[180px] items-center">
        <div className="h-3 w-[206px] animate-skeleton rounded-full bg-border" />
      </div>
      <div className="flex w-[130px] max-w-[130px] items-center">
        <div className="h-3 w-full animate-skeleton rounded-full bg-border" />
      </div>
      <div className="w-[180px] max-w-[180px]">
        <div className="flex h-[42px] items-center justify-between rounded border border-solid border-border bg-white px-3">
          <span />
          <MaterialIcon name="keyboard_arrow_down" className="text-xl text-placeholder" />
        </div>
      </div>
      <div className="w-[188px] max-w-[188px] min-w-[188px] px-1">
        <div className="h-[62px] rounded border border-solid border-border bg-white" />
      </div>
    </div>
  );
}

function ProfitListEmpty() {
  return (
    <div className="flex flex-col items-center gap-lg py-xl">
      <p className="text-base font-bold text-sub">表示するデータがありません</p>
      <img src="/agent/job_change_processes/no-data.svg" alt="" width={148} height={144} />
    </div>
  );
}

export default function ProfitsList({
  profits,
  isLoading,
  onAction,
  isSidebarOpen,
  openSidebar,
}: Props) {
  return (
    <div className="relative flex flex-col">
      {/* ヘッダー */}
      <div className="sticky top-4 z-20 flex min-h-[36px] items-center justify-around rounded-s bg-[#E7E7E7] px-6 py-1.5">
        <p className="w-[180px] min-w-[180px] text-center text-sm font-bold">求職者</p>
        <p className="w-[180px] min-w-[180px] text-center text-sm font-bold">企業</p>
        <p className="w-[130px] max-w-[130px] text-center text-sm font-bold">売上金額</p>
        <p className="w-[180px] max-w-[180px] text-center text-sm font-bold">ステータス</p>
        <p className="w-[188px] max-w-[188px] min-w-[188px] text-center text-sm font-bold">メモ</p>
      </div>

      {/* カードリスト */}
      <div className="hidden-scrollbar flex flex-col gap-3 px-1 pt-4">
        {isLoading ? (
          <>
            {Array.from({ length: 4 }).map((_, index) => (
              <ProfitCardSkeleton key={index} />
            ))}
          </>
        ) : profits.length === 0 ? (
          <ProfitListEmpty />
        ) : (
          profits.map((profit) => (
            <ProfitCardItem
              key={profit.id}
              profit={profit}
              onAction={onAction}
              isSidebarOpen={isSidebarOpen}
              openSidebar={openSidebar}
            />
          ))
        )}
      </div>
    </div>
  );
}
